let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("afbg4")).then(() => parcelRequire('4ZJrP'));